// lib/api.ts
import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "lib/rtkQueryAxiosBase";

export const tradeasyApi = createApi({
  reducerPath: "tradeasyApi",
  baseQuery: axiosBaseQuery(), // ⬅️ usa tu customAxios por debajo
  endpoints: (builder) => ({
    getAllTickers: builder.query({
      query: () => ({ url: "tickers/" }),
    }),
    getTicker: builder.query({
      query: (id) => ({ url: `tickers/${id}` }),
    }),
    getAllTimeframes: builder.query({
      query: () => ({ url: "timeframes/" }),
    }),
    getTimeframe: builder.query({
      query: (id) => ({ url: `timeframes/${id}` }),
    }),
    getUserSummary: builder.query({
      query: (id) => ({ url: `strategies/user/summary` }),
    }),
    getAllSharedStrategies: builder.query({
      query: () => ({ url: "sharedStrategies/" }),
    }),
    getNews: builder.query({
      query: () => ({ url: "news/" }),
    }),
    getUserStrategies: builder.query({
      query: (id) => ({ url: `strategies/user` }),
    }),
    getAllSharedRobots: builder.query({
      query: () => ({ url: "sharedRobots/" }),
    }),
    getUserRobots: builder.query({
      query: (id) => ({ url: `robots/user` }),
    }),
    // ejemplo extra: descarga blob
    downloadReport: builder.query<Blob, void>({
      query: () => ({ url: "report", responseType: "blob" }),
    }),
  }),
});

export const {
  useGetAllTimeframesQuery,
  useGetTickerQuery,
  useGetAllTickersQuery,
  useGetTimeframeQuery,
  useGetAllSharedStrategiesQuery,
  useGetUserSummaryQuery,
  useGetNewsQuery,
  useGetUserStrategiesQuery,
  useGetAllSharedRobotsQuery,
  useGetUserRobotsQuery,
  useDownloadReportQuery,
} = tradeasyApi;
